import moment from 'moment-timezone';

export function toReadableTime(time) {
  const a = time.split(':');
  const m = moment().hours(parseInt(a[0])).minutes(parseInt(a[1])).seconds(parseInt(a[2]));
  return m.format('h:mm A');
}
